import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { GlanceLoader as GlanceLoaderSvelte } from '@glance-networks/ui-core-components';

export const GlanceLoader = (props) => {
  const defineProps = {
    size: props.size || 14,
    spinning: props.spinning || false,
  };

  return (
    <Svelte component={GlanceLoaderSvelte} {...defineProps} />
  );
};
